import {lazy} from 'react';

export const EmployeeListLazy = lazy(() => import(/* webpackChunkName: "employeeList" */ '.'));
